import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import extend from 'lodash/extend';
import withRouter from 'react-router/withRouter';
import Ad from '../../../../components/ad/ad';
import Slug from '../../../../components/slug/slug';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import FranchiseAccordionSection from '../../../../components/franchise_accordion_section/franchise_accordion_section';
import loadData from './company_index_section_page_state_manager';

// eslint-disable-next-line react/prefer-stateless-function
class CompanyIndexSectionPage extends Component {
  static loadData(store) {
    return loadData(store);
  }

  constructor(props) {
    super(props);

    this.alphabet = [
      '0-9',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z'
    ];
  }

  render() {
    if (this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.companyIndexSectionPage.isLoading) {
      return (
        <section className="company-page">
          <article className="company-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { companyIndexSectionData, companyIndexSectionNextData } = this.props;
    const adData = get(this.props, 'companyIndexSectionPage.ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const pgTitle = 'company index';
    const pgDesc =
      'A list of companies Fast Company has featured including the Most Innovative';
    const section = get(this.props, 'match.params.section');
    const page = Number(get(this.props, 'match.params.page'));
    const nextPage =
      page && !isEmpty(companyIndexSectionNextData) ? String(page + 1) : null;
    const prevPage = page > 1 ? String(page - 1) : null;

    return (
      <section className="company-index-page">
        <Ad {...combinedAdModel} name="oop" slug={false} oop={true} />
        <section className="page-title company-index-page__page-title">
          <Slug slugName={pgTitle} className="category-page" />
          <h3 className="page-description">{pgDesc}</h3>
        </section>

        {this.alphabet.map(letter => (
          <FranchiseAccordionSection
            combinedAdModel={combinedAdModel}
            index={letter}
            key={letter}
            data={companyIndexSectionData}
            propertyToDisplay="name"
            prevPage={prevPage}
            nextPage={nextPage}
            activeSection={section}
            pathForSection="company"
            pathForData="company"
          />
        ))}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    companyIndexSectionData: get(state, 'companyIndexSection.data') || {},
    companyIndexSectionNextData:
      get(state, 'companyIndexSectionNext.data') || {},
    companyIndexSectionPage: Object.keys(get(state, 'companyIndexPage')).length
      ? get(state, 'companyIndexPage')
      : get(state, 'companyIndexSectionPage') || {}
  };
}

CompanyIndexSectionPage.defaultProps = {
  status: 200,
  companyIndexSectionData: {},
  companyIndexSectionNextData: {},
  companyIndexSectionPage: {}
};

CompanyIndexSectionPage.propTypes = {
  status: PropTypes.number,
  companyIndexSectionData: PropTypes.shape({}),
  companyIndexSectionNextData: PropTypes.shape({}),
  companyIndexSectionPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  })
};

export default withRouter(connect(mapStateToProps)(CompanyIndexSectionPage));
